import { useAsync } from '@shared/async';
import React from 'react';

import { ConfirmationDialog } from '@/components/delete-confirmation-dialog';
import { BoardMeeting } from '@/types/board-meetings';

import { useBoardMeetingService } from '../api';

type CancelBoardMeetingDialogProps = {
  /**
   * The board meeting to cancel. If null, this modal will be closed.
   */
  boardMeeting: BoardMeeting | null;

  /**
   * Event handler when the user cancels the operation.
   */
  onCancel: () => void;

  /**
   * Event handler once the cancel has occurred on the server.
   */
  onCancelComplete: () => void;
};

/**
 * Handles cancellation of a Board Meeting.
 */
export const CancelBoardMeetingDialog = ({ boardMeeting, onCancel, onCancelComplete }: CancelBoardMeetingDialogProps) => {
  const { cancelBoardMeeting } = useBoardMeetingService();
  const cancelAsync = useAsync(cancelBoardMeeting);

  return (
    <ConfirmationDialog
      open={boardMeeting !== null}
      title="Cancel Board Meeting"
      message={`Are you sure you want to cancel this board meeting scheduled for ${boardMeeting?.startTime?.toLocaleString()}?`}
      confirmLabel="Cancel Meeting"
      cancelLabel="Keep Meeting"
      confirmColor="zinc"
      itemName="Board Meeting"
      successTitle="Meeting Cancelled"
      successMessage="Board meeting has been successfully cancelled."
      onCancel={onCancel}
      onActionComplete={onCancelComplete}
      request={cancelAsync}
      parameters={boardMeeting ? [boardMeeting.id] : []}
    />
  );
};